import React, { useEffect, useState } from 'react';
import { FaRegCircleXmark } from 'react-icons/fa6';
import { MdDelete } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import { toast } from 'react-toastify';
import { mainurl } from '../../actions/mainurl';
import { useDispatch, useSelector } from 'react-redux';
import { getContactData } from '../../actions/ContactAction';

function Contact() {
    const baseUrl = mainurl;
    const { user } = useSelector((action) => action.authState);
    const { allContact } = useSelector((state) => state.contactState);
    const [selectedContact, setSelectedContact] = useState(null);
    const [itemOffset, setItemOffset] = useState(0);
    const [deleteData, setDeleteData] = useState('');
    const dispatch = useDispatch();
    const itemsPerPage = 10;
    const canDeleteContact = user?.role === 'super-admin';

    useEffect(() => {
        dispatch(getContactData);
    }, [deleteData, dispatch]);

    const handleQuerieDelete = async (id) => {
        if (user?.role !== 'super-admin') {
            return toast.error(`Role ${user?.role} is not allowed to delete`);
        }

        const confirmDelete = window.confirm('Are you sure you want to delete');

        if (!confirmDelete) {
            return;
        }

        try {
            await axios.delete(`${baseUrl}/contact/delete-contact/${id}`, {
                withCredentials: true,
            });
            toast.success('Successfully deleted');
            setDeleteData(id);
        } catch (error) {
            console.error('Error deleting contact:', error);
        }
    };

    const handleViewDetails = (contact) => {
        setSelectedContact(contact);
    };

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % allContact?.length;
        setItemOffset(newOffset);
    };

    const endOffset = itemOffset + itemsPerPage;
    const currentItems = allContact?.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(allContact?.length / itemsPerPage);

    return (
        <div className="query">
            <h2 className="main_heading">All Contacts</h2>
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Message</th>
                        <th>Details</th>
                        {canDeleteContact && <th>Action</th>}
                    </tr>
                </thead>
                <tbody>
                    {currentItems &&
                        currentItems?.map((data, index) => (
                            <React.Fragment key={index}>
                                <tr>
                                    <td className="query_name">{data.firstName} {data.lastName}</td>
                                    <td className="query_email">{data.email}</td>
                                    <td className="query_email">{data.phone}</td>
                                    <td className="query_content">
                                        {data.message?.length > 50 ? `${data.message.substring(0, 30)}... ` : data.message}
                                    </td>
                                    <td>
                                        <button className="querie_more_button" onClick={() => handleViewDetails(data)}>
                                            View Details
                                        </button>
                                    </td>
                                    {canDeleteContact && (
                                        <td>
                                            <button className="querie_button" onClick={() => handleQuerieDelete(data._id)}>
                                                <MdDelete className="icon" />
                                            </button>
                                        </td>
                                    )}
                                </tr>
                                {selectedContact && selectedContact._id === data._id && (
                                    <tr>
                                        <td>
                                            <div className="showMore_popup_background"></div>
                                            <div className="showMore_popup">
                                                <div>
                                                    <FaRegCircleXmark className="query_close_icon" onClick={() => setSelectedContact(null)} />
                                                </div>
                                                <div className="query_popup_div">
                                                    <div>
                                                        <b>Name:</b> {selectedContact.firstName} {selectedContact.lastName}
                                                    </div>
                                                    <div>
                                                        <b>Email:</b> {selectedContact.email}
                                                    </div>
                                                    <p>
                                                        <b>Message:</b> {selectedContact.message}
                                                    </p>
                                                    <p>
                                                        <b>Phone:</b> {selectedContact.phone}
                                                    </p>
                                                    <p>
                                                        <b>Telegram:</b> {selectedContact.telegram ? selectedContact.telegram : 'None'}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                </tbody>
            </table>
            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />
        </div>
    );
}

export default Contact;
